import globalMsg from '@/lang/i18n';

export const commonI18n = {
  en: {
    home: 'Home',
    back: 'Back',
    next: 'Next',
    empty: 'Empty',
    video: 'Video',
    image: 'Image(s)',
    file: 'File',
    files: 'Files',
    pdf: 'Pdf',
    text: 'Text',
    test: 'Test',
    link: 'Link',
    loading: 'Loading',
    saving: 'Saving',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    validate: 'Validate',
    description: 'Description',
    name: 'Name',
    deleting: 'Removing',
    edit: 'Edit',
    remove: 'Delete',
    reorder: 'Reorder',
    processing: 'Processing',
    add: 'Add',
    tutoring: 'Tutoring',
    myCourses: 'My Courses',
    content: 'Content',
    prev: 'Prev',
    tasks: 'Tasks',
    currentLessons: 'Current Lessons',
    recentNotes: 'Recent Notes',
    institution: 'Institution',
    register: 'Register',
    myContent: 'My Content',
    myClasses: 'My Classes',
    pleaseSelect: 'Select...',
    comingSoon: 'Coming soon',
    pleaseConfirm: 'Please confirm',
    accept: 'Accept',
    seeMore: 'See more',
    homework:'This is a homework',
    addReponse: 'Add Response',
    sendingResponse: 'Sending Response',
    startAt: 'Start at',
    endAt: 'End at',
    search: 'Search',
    selectAll: 'Select all',
    information: 'Information',
    courses: 'Subjects',
    users: 'Users',
    date: 'Date',
    hour: 'Hour',
    tryAgain: 'Try again',
    today: 'Today',
    tomorrow: 'Tomorrow',
    to: 'To',
    at: 'At',
    from: 'From',
    join: 'Join',
    select: 'Select',
    youtube: 'Youtube',
    upload: 'Upload',
    searching: 'Searching',
    response:'Response',
    homeworkResponseSent: 'Homework response sent',
    notFound: 'Not found',
    send: 'Send',
    saved: 'Saved',
    menu: 'Menu',
    now: 'now',
    ok: 'Ok',
    go: 'Go',
    verifiyingInformation: 'Verifiying information',
    run: 'Run',
    apply: 'Apply',
    move: 'Move',
    continue: 'Continue',
    tags: {
      test: 'Test',
      homework: 'Homework',
      classwork: 'Classwork'
    },
    weekdays: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday'
    },
    shorWeekdays: {
      sunday: 'Sun',
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat'
    },
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    day: 'Day',
    refresh: 'Refresh',
    coomingSoon: 'Cooming soon',
    wait: 'Wait',
    ...globalMsg.en.common,
    lesson: 'Lesson',
    toLabel: 'to',
    components: 'Components',
    error403: {
      title: '403',
      subtitle: 'Access Restricted!',
      description: 'We have detected an unauthorized attempt to access this part of the app. We\'re afraid you don\'t have the necessary permission to visit this page.',
      disclamer: 'If you believe this is a mistake, please contact our support team or return to the Home Page. If you have another account with sufficient access, please consider logging in with that account. Please ensure that you have the right URL, and also consider clearing your browser cache and cookies in case there\'s an issue related to old, stored data. We appreciate your understanding and patience.',
    },
    fieldErrors: {
      greatherThanZero: 'This field must be greater than zero',
    },
    addTemplate: 'Add Template',
  },
  es: {
    home: 'Inicio',
    back: 'Atras',
    next: 'Siguiente',
    empty: 'Vacío',
    video: 'Video',
    image: 'Imagen(es)',
    file: 'Archivo',
    files: 'Archivos',
    pdf: 'Pdf',
    text: 'Texto',
    test: 'Prueba',
    link: 'Enlace',
    loading: 'Cargando',
    saving: 'Guardando',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Guardar',
    validate: 'Validar',
    description: 'Descripción',
    name: 'Nombre',
    deleting: 'Eliminando',
    edit: 'Editar',
    remove: 'Eliminar',
    reorder: 'Reordenar',
    processing: 'Procesando',
    add: 'Añadir',
    tutoring: 'Tutoring',
    myCourses: 'Mis cursos',
    continue: 'Continuar',
    content: 'Contenido',
    prev: 'Anterior',
    tasks: 'Tareas',
    currentLessons: 'Lecciones Actuales',
    recentNotes: 'Notas Recientes',
    institution: 'Institución',
    register: 'Registro',
    myContent: 'Mi contenido',
    myClasses: 'Mis clases',
    pleaseSelect: 'Selecciona...',
    comingSoon: 'Próximamente disponible',
    pleaseConfirm: 'Por favor confirma',
    accept: 'Aceptar',
    seeMore: 'Ver más',
    homework:'Esta es una tarea',
    addReponse: 'Agregar Respuesta',
    sendingResponse: 'Enviando Respuesta',
    startAt: 'Inicia',
    endAt: 'Termina',
    search: 'Buscar',
    selectAll: 'Seleccionar todos',
    information: 'Información',
    courses: 'Cursos',
    users: 'Usuarios',
    date: 'Fecha',
    hour: 'Hora',
    tryAgain: 'Intentar de nuevo',
    today: 'Hoy',
    tomorrow: 'Mañana',
    to: 'Hasta',
    at: 'a las',
    from: 'Desde',
    join: 'Unirse',
    select: 'Seleccionar',
    youtube: 'Youtube',
    upload: 'Cargar',
    searching: 'Buscando',
    response: 'respuesta',
    homeworkResponseSent: 'Respuesta de Tarea enviada',
    notFound: 'No hay resultados',
    send: 'Enviar',
    saved: 'Guardado',
    menu: 'Menú',
    now: 'ahora',
    ok: 'Ok',
    run: 'Ejecutar',
    go: 'Ir',
    verifiyingInformation: 'Verificando información',
    apply: 'Aplicar',
    move: 'Mover',
    tags: {
      test: 'Exámen',
      homework: 'Tarea',
      classwork: 'Trabajo en Clase'
    },
    weekdays: {
      sunday: 'Domingo',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado'
    },
    shorWeekdays: {
      sunday: 'Dom',
      monday: 'Lun',
      tuesday: 'Mar',
      wednesday: 'Mie',
      thursday: 'Jue',
      friday: 'Vie',
      saturday: 'Sab'
    },
    months: {
      january: 'Enero',
      february: 'Febrero',
      march: 'Marzo',
      april: 'Abril',
      may: 'Mayo',
      june: 'Junio',
      july: 'Julio',
      august: 'Agosto',
      september: 'Septiembre',
      october: 'Octubre',
      november: 'Noviembre',
      december: 'Diciembre',
    },
    day: 'Día',
    refresh: 'Refrescar',
    coomingSoon: 'Próximamente',
    wait: 'Esperar',
    ...globalMsg.es.common,
    lesson: 'Lección',
    toLabel: 'a',
    components: 'Componentes',
    error403: {
      title: '403',
      subtitle: '¡Acceso Restringido!',
      description: 'Hemos detectado un intento no autorizado de acceder a esta parte de la aplicación. Lamentablemente, no tienes los permisos necesarios para visitar esta página.',
      disclamer: 'Si crees que esto es un error, por favor contacta a nuestro equipo de soporte o regresa a la página de inicio. Si tienes otra cuenta con suficiente acceso, por favor considera iniciar sesión con esa cuenta. Por favor asegúrate de tener la URL correcta, y también considera limpiar la caché y las cookies de tu navegador en caso de que haya un problema relacionado con datos antiguos. Agradecemos tu comprensión y paciencia.',
    },
    fieldErrors: {
      greatherThanZero: 'Este campo debe ser mayor a cero'
    },
    addTemplate: 'Agregar Plantilla',
  }
};
